import { Alert } from 'antd';
import { Link } from 'react-router-dom';

import { useGetCertProposalsQuery } from '../../redux/api/material-certs';

/**
 * Reduce a PO label to the digits both systems agree on.
 *
 * ERP stores `PO-5653`; proposals store `5653`. Sending the label into an
 * exact-match filter matched nothing, so this banner never rendered.
 */
function poSearchKey(po?: string | null): string | undefined {
	if (!po) return undefined;
	const digits = po.replace(/\D/g, '').replace(/^0+/, '');
	return digits || po;
}

/**
 * Nudge on a material order when Alro certificates for its PO are still
 * unreviewed, so receiving notices without going looking for the queue.
 * Renders nothing when there is no PO or nothing pending.
 */
export default function PoCertBanner({ po }: { po?: string | null }) {
	const poKey = poSearchKey(po);
	const { data: proposals } = useGetCertProposalsQuery(
		{ po: poKey, status: 'pending' },
		{ skip: !poKey }
	);

	const pending = proposals?.length ?? 0;
	if (!po || !pending) return null;

	const ready = proposals?.filter((row) => row.bucket === 'ready').length ?? 0;

	return (
		<Alert
			type={ready ? 'warning' : 'info'}
			showIcon
			style={{ marginBottom: 8 }}
			message={
				<>
					{pending} material certificate{pending === 1 ? '' : 's'} for PO {po}{' '}
					{pending === 1 ? 'is' : 'are'} waiting on review
					{ready ? `, ${ready} ready to attach` : ''}.{' '}
					<Link to="/material/certificates">Open the queue</Link>
				</>
			}
		/>
	);
}
